<div [formGroup]="form" [class]="class">
  <mat-label class="label-form">{{ meta.label }}:</mat-label>
  <mat-slide-toggle
    class="w-full mt-3"
    [formControlName]="meta.key"
    (change)="customActionInput($event)"
  >
    {{ meta.value }}
  </mat-slide-toggle>
  <app-box-errors [meta]="meta" [control]="control" [submitted]="submitted"></app-box-errors>
</div>
